import axios from "axios";
import API_BASE_URL from "./apiConfig";

const API_URL = `${API_BASE_URL}/api`;

const patientService = {
  async getPatients(doctorId, page = 1, limit = 10) {
    try {
      const url = doctorId
        ? `${API_URL}/patients?doctorId=${doctorId}&page=${page}&limit=${limit}`
        : `${API_URL}/patients?page=${page}&limit=${limit}`;
      console.log("Fetching patients from URL:", url);
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getPatientById(id, doctorId = null, isAdmin = false) {
    try { 
      let url = `${API_URL}/patients/${id}`;
      const params = new URLSearchParams();
      if (doctorId) params.append('doctorId', doctorId);
      if (isAdmin) params.append('isAdmin', isAdmin);
      if (params.toString()) url += `?${params.toString()}`;
      
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async createPatient(patientData) {
    try {
      const response = await axios.post(
        `${API_URL}/patients`,
        patientData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async updatePatient(id, patientData) {
    try {
      const response = await axios.put(
        `${API_URL}/patients/${id}`,
        patientData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async deletePatient(id) {
    try {
      const response = await axios.delete(`${API_URL}/patients/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async searchPatients(searchQuery, doctorId) {
    try {
      const url = doctorId
        ? `${API_URL}/patients/search?q=${encodeURIComponent(searchQuery)}&doctorId=${doctorId}`
        : `${API_URL}/patients/search?q=${encodeURIComponent(searchQuery)}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default patientService;
